
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/addresses",
      function () {
        return require("private-next-pages/account/addresses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/addresses"])
      });
    }
  